import { InputSelectControlField } from '@sequencehq/core-components'

/**
 * How the credited amount is settled: applied against the invoice's amount due
 * (the issue-and-apply flow), or refunded outside Sequence, in which case the
 * credit note is only created as a draft.
 */
export type ApplyCreditOption = 'ADJUST_AMOUNT_DUE' | 'REFUND_MANUALLY'

const APPLY_CREDIT_OPTIONS: Array<{ value: ApplyCreditOption; label: string }> =
  [
    { value: 'ADJUST_AMOUNT_DUE', label: 'Adjust invoice amount due' },
    { value: 'REFUND_MANUALLY', label: 'Refund manually' }
  ]

export const ApplyCreditSection = ({
  value,
  onChange,
  disabled = false
}: {
  value: ApplyCreditOption
  onChange: (value: ApplyCreditOption) => void
  disabled?: boolean
}) => (
  <InputSelectControlField
    label="Apply credit"
    value={value}
    options={APPLY_CREDIT_OPTIONS}
    onChange={newValue => onChange(newValue as ApplyCreditOption)}
    disabled={disabled}
    data-testid="issue-credit-note.apply-credit"
  />
)
